import './index.scss'

const AnimatedLetters = ({ letterClass, strArray, idx, mobileView }) => {
  const checkDataContent = (strArr) => {
    console.warn('mobileView && strArr', mobileView, strArr)
    if (mobileView && strArr.length === 12) {
      return strArr.slice(0, -1)
    } else if (mobileView && strArr.length === 21) {
      return [...strArr.slice(0, -7), strArr.slice(-1)]
    }
    return strArr
  }

  console.warn('strArray', strArray)
  return (
    <span>
      {strArray?.length
        ? checkDataContent(strArray)?.map((char, i) => (
            <span key={char + i} className={`${letterClass} _${i + idx}`}>
              {char}
            </span>
          ))
        : ''}
    </span>
  )
}

export default AnimatedLetters
